import { Injectable } from '@angular/core';
import { arrayNotEmpty } from 'class-validator';
import { BasicResponse } from 'src/app/core/models/basic-response.model';
import { getConnection } from 'src/app/core/services/functions.service';
import { QueriesService } from 'src/app/core/services/queries.service';
import { environment } from 'src/environments/environment';
import { ModuloMenuSicfModel } from '../models/modulo-menu.model';

@Injectable({
  providedIn: 'root'
})
export class OpcionesMenuService {

  private MODULOS_TABLE: string = "modulos_sicf"
  private ROLES_TABLE: string = "menu_roles_sicf"
  private TABLA_PRINCIPAL: string = "menu_sicf"

  constructor(
    private queriesService: QueriesService,
  ) { }

  async findAll(codigo_modulo: string = "", fields: string[] = [], excludedOptions: string[] = []): Promise<BasicResponse> {
    const query = this.queriesService.table(`${this.TABLA_PRINCIPAL} op INNER JOIN ${this.MODULOS_TABLE} mo ON (op.codigo_modulo = mo.codigo_modulo)`)
      .where(`mo.VERSION_JAMARADMIN ${environment.version ? `= '${environment.version}'` : `IS NULL`} 
      ${codigo_modulo != "" ? ` AND mo.codigo_modulo = '${codigo_modulo}'` : ""}
      ${excludedOptions.length > 0 ? ` AND codigo_opcion NOT IN (${excludedOptions.join(",")})` : ""}`)
    if (fields.length > 0) {
      query.selectWithArray(fields)
    } else {
      query.select("op.codigo_opcion as codigo", `mo.descripcion_modulo as modulo`, "descripcion_opcion as opcion", "estado")
    }
    const result = await query.execute()
    return result
  }

  async findAllByRole(codigo_rol: string): Promise<BasicResponse> {
    const query = this.queriesService.table(`${this.TABLA_PRINCIPAL} op INNER JOIN ${this.MODULOS_TABLE} mo ON (op.codigo_modulo = mo.codigo_modulo) INNER JOIN ${this.ROLES_TABLE} roles ON (roles.codigo_opcion = op.codigo_opcion)`)
    query.where(`mo.VERSION_JAMARADMIN ${environment.version ? `= '${environment.version}'` : `IS NULL`} AND codigo_rol = '${codigo_rol}'`)
    query.select("op.codigo_opcion as codigo", `mo.descripcion_modulo as modulo`, "descripcion_opcion as opcion", "estado", "mo.codigo_modulo")
    const result = await query.execute()
    return result
  }

  async findAllByModule(codigo_modulo: string): Promise<BasicResponse> {
    const result = await this.queriesService.table(this.TABLA_PRINCIPAL).where({ codigo_modulo }).execute()
    return result
  }

  async findOne(codigo_opcion: string): Promise<BasicResponse> {
    const result = await this.queriesService.table(this.TABLA_PRINCIPAL).where({ codigo_opcion }).execute()
    result.data = arrayNotEmpty(result.data) ? result.data[0] : null
    return result
  }

  async create(value: ModuloMenuSicfModel): Promise<BasicResponse> {
    let id = (await this.queriesService
      .table(this.TABLA_PRINCIPAL)
      .select(`(TO_CHAR(MAX(id)) + 1) as max`)
      .execute()).data[0].max
    id = Number(id)
    let codigo_opcion = (await this.queriesService.table(this.TABLA_PRINCIPAL)
      .select("(TO_CHAR(max((to_number(codigo_opcion))))+1) as id")
      .where("REGEXP_LIKE(codigo_opcion, '^[[:digit:]]+$') AND codigo_opcion not like '0%'")
      .execute()).data[0].id
    codigo_opcion = Number(codigo_opcion)
    let result = await this.queriesService.table(this.TABLA_PRINCIPAL).insert({ c_emp: getConnection(), id: id, codigo_opcion: codigo_opcion, ...value }).execute()
    return result
  }

  async update(value: any, where: any) {
    value.codigo_padre = value.codigo_padre && value.codigo_padre != "" ? value.codigo_padre : null
    const result = await this.queriesService.table(this.TABLA_PRINCIPAL).update(value, where, 1).execute()
    return result
  }
}